(() => {
    "use strict";

/* =========================================
   ALEVA
   Main Interaction Controller
========================================= */


/* =========================================
   GLOBAL ELEMENTS
========================================= */

const header =
    document.querySelector("#siteHeader");

const overlay =
    document.querySelector("#pageOverlay");


/* =========================================
   DESKTOP MEGA MENU
========================================= */

const megaTriggers =
    [...document.querySelectorAll(".mega-trigger")];

const megaPanels =
    [...document.querySelectorAll(".mega-panel")];


let activeMegaMenu = null;
let closeTimer = null;
let pointerOpenedMegaMenu = null;


function showOverlay() {

    overlay?.classList.add("is-visible");

    overlay?.setAttribute(
        "aria-hidden",
        "false"
    );

}


function hideOverlay() {

    overlay?.classList.remove("is-visible");

    overlay?.setAttribute(
        "aria-hidden",
        "true"
    );

}


function openMegaMenu(menuName) {

    if (window.innerWidth <= 1080) {
        return;
    }


    window.clearTimeout(closeTimer);

    activeMegaMenu = menuName;


    megaTriggers.forEach((trigger) => {

        const isActive =
            trigger.dataset.menu === menuName;


        trigger.classList.toggle(
            "is-active",
            isActive
        );


        trigger.setAttribute(
            "aria-expanded",
            String(isActive)
        );

    });


    megaPanels.forEach((panel) => {

        const isActive =
            panel.dataset.panel === menuName;


        panel.classList.toggle(
            "is-open",
            isActive
        );


        panel.setAttribute(
            "aria-hidden",
            String(!isActive)
        );

    });


    showOverlay();

}


function closeMegaMenu() {

    activeMegaMenu = null;
    pointerOpenedMegaMenu = null;


    megaTriggers.forEach((trigger) => {

        trigger.classList.remove(
            "is-active"
        );


        trigger.setAttribute(
            "aria-expanded",
            "false"
        );

    });


    megaPanels.forEach((panel) => {

        panel.classList.remove(
            "is-open"
        );


        panel.setAttribute(
            "aria-hidden",
            "true"
        );

    });


    if (
        !mobileNavigation?.classList.contains(
            "is-open"
        )
    ) {

        hideOverlay();

    }

}


/* CLICK */

megaTriggers.forEach((trigger) => {

    trigger.addEventListener(
        "click",
        (event) => {

            event.stopPropagation();


            const menuName =
                trigger.dataset.menu;


            if (
                window.innerWidth > 1080 &&
                event.detail > 0 &&
                pointerOpenedMegaMenu === menuName &&
                activeMegaMenu === menuName
            ) {

                pointerOpenedMegaMenu = null;
                return;

            }


            pointerOpenedMegaMenu = null;


            if (activeMegaMenu === menuName) {

                closeMegaMenu();

            } else {

                openMegaMenu(menuName);

            }

        }
    );

});


/* DESKTOP HOVER */

megaTriggers.forEach((trigger) => {

    trigger.addEventListener(
        "mouseenter",
        () => {

            if (window.innerWidth <= 1080) {
                return;
            }


            const menuName =
                trigger.dataset.menu;


            const openedByPointer =
                activeMegaMenu !== menuName;


            openMegaMenu(
                menuName
            );


            pointerOpenedMegaMenu =
                openedByPointer
                    ? menuName
                    : null;

        }
    );

});


header?.addEventListener(
    "mouseleave",
    () => {

        if (window.innerWidth <= 1080) {
            return;
        }


        closeTimer =
            window.setTimeout(
                closeMegaMenu,
                190
            );

    }
);


header?.addEventListener(
    "mouseenter",
    () => {

        window.clearTimeout(
            closeTimer
        );

    }
);


/* =========================================
   MOBILE MENU
========================================= */

const mobileMenuButton =
    document.querySelector(
        "#mobileMenuButton"
    );

const mobileNavigation =
    document.querySelector(
        "#mobileNavigation"
    );

const mobileMenuClose =
    document.querySelector(
        "#mobileMenuClose"
    );

const mobileNavigationShell =
    document.querySelector(
        ".mobile-navigation-shell"
    );

const mobileAccordionSections =
    [...document.querySelectorAll(
        ".mobile-nav-section"
    )];

const mobileAccordionTriggers =
    [...document.querySelectorAll(
        ".mobile-accordion-trigger"
    )];

const mobileLanguageButtons =
    [...document.querySelectorAll(
        ".mobile-language-switcher button"
    )];


let lastFocusedElement = null;


/* =========================================
   MOBILE ACCORDION
========================================= */

function setMobileAccordion(
    sectionToOpen
) {

    mobileAccordionSections.forEach(
        (section) => {

            const trigger =
                section.querySelector(
                    ".mobile-accordion-trigger"
                );

            const content =
                section.querySelector(
                    ".mobile-accordion-content"
                );

            const shouldOpen =
                section === sectionToOpen;


            section.classList.toggle(
                "is-open",
                shouldOpen
            );


            trigger?.setAttribute(
                "aria-expanded",
                String(shouldOpen)
            );


            content?.setAttribute(
                "aria-hidden",
                String(!shouldOpen)
            );

        }
    );

}


mobileAccordionTriggers.forEach(
    (trigger) => {

        trigger.addEventListener(
            "click",
            () => {

                const section =
                    trigger.closest(
                        ".mobile-nav-section"
                    );


                if (!section) {
                    return;
                }


                const isOpen =
                    section.classList.contains(
                        "is-open"
                    );


                if (isOpen) {

                    section.classList.remove(
                        "is-open"
                    );


                    trigger.setAttribute(
                        "aria-expanded",
                        "false"
                    );


                    section
                        .querySelector(
                            ".mobile-accordion-content"
                        )
                        ?.setAttribute(
                            "aria-hidden",
                            "true"
                        );

                    return;
                }


                setMobileAccordion(section);

            }
        );

    }
);


/* =========================================
   OPEN / CLOSE MOBILE MENU
========================================= */

function openMobileMenu() {

    if (
        !mobileMenuButton ||
        !mobileNavigation
    ) {
        return;
    }


    closeMegaMenu();


    lastFocusedElement =
        document.activeElement;


    mobileMenuButton.classList.add(
        "is-open"
    );


    mobileNavigation.classList.add(
        "is-open"
    );


    mobileMenuButton.setAttribute(
        "aria-expanded",
        "true"
    );


    mobileNavigation.setAttribute(
        "aria-hidden",
        "false"
    );


    document.body.classList.add(
        "menu-lock"
    );


    showOverlay();


    window.requestAnimationFrame(
        () => {

            mobileMenuClose?.focus();

        }
    );

}


function closeMobileMenu(
    restoreFocus = true
) {

    if (
        !mobileMenuButton ||
        !mobileNavigation
    ) {
        return;
    }


    const wasOpen =
        mobileNavigation.classList.contains(
            "is-open"
        );


    mobileMenuButton.classList.remove(
        "is-open"
    );


    mobileNavigation.classList.remove(
        "is-open"
    );


    mobileMenuButton.setAttribute(
        "aria-expanded",
        "false"
    );


    mobileNavigation.setAttribute(
        "aria-hidden",
        "true"
    );


    document.body.classList.remove(
        "menu-lock"
    );


    if (!activeMegaMenu) {

        hideOverlay();

    }


    if (
        wasOpen &&
        restoreFocus &&
        lastFocusedElement instanceof HTMLElement
    ) {

        lastFocusedElement.focus();

    }

}


mobileMenuButton?.addEventListener(
    "click",
    () => {

        const isOpen =
            mobileNavigation?.classList.contains(
                "is-open"
            );


        if (isOpen) {

            closeMobileMenu();

        } else {

            openMobileMenu();

        }

    }
);


mobileMenuClose?.addEventListener(
    "click",
    () => {

        closeMobileMenu();

    }
);


/* CLOSE AFTER LINK CLICK */

mobileNavigation
    ?.querySelectorAll("a")
    .forEach((link) => {

        link.addEventListener(
            "click",
            () => {

                closeMobileMenu(false);

            }
        );

    });


/* =========================================
   MOBILE LANGUAGE UI
========================================= */

mobileLanguageButtons.forEach(
    (button) => {

        button.addEventListener(
            "click",
            () => {

                mobileLanguageButtons.forEach(
                    (item) => {

                        item.classList.remove(
                            "is-active"
                        );

                    }
                );


                button.classList.add(
                    "is-active"
                );

            }
        );

    }
);


/* =========================================
   OVERLAY / ESCAPE
========================================= */

overlay?.addEventListener(
    "click",
    () => {

        closeMegaMenu();
        closeMobileMenu();

    }
);


document.addEventListener(
    "keydown",
    (event) => {

        if (event.key === "Escape") {

            closeMegaMenu();
            closeMobileMenu();

        }

    }
);


/* KEEP KEYBOARD FOCUS INSIDE MOBILE MENU */

document.addEventListener(
    "keydown",
    (event) => {

        if (
            event.key !== "Tab" ||
            !mobileNavigation?.classList.contains(
                "is-open"
            ) ||
            !mobileNavigationShell
        ) {
            return;
        }


        const focusable =
            [...mobileNavigationShell.querySelectorAll(
                'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
            )].filter(
                (element) =>
                    element.offsetParent !== null
            );


        if (!focusable.length) {
            return;
        }


        const first =
            focusable[0];

        const last =
            focusable[
                focusable.length - 1
            ];


        if (
            event.shiftKey &&
            document.activeElement === first
        ) {

            event.preventDefault();
            last.focus();

        } else if (
            !event.shiftKey &&
            document.activeElement === last
        ) {

            event.preventDefault();
            first.focus();

        }

    }
);


/* =========================================
   HERO SLIDER
========================================= */

const heroSlider =
    document.querySelector(
        "#heroSlider"
    );

const heroSlides =
    [...document.querySelectorAll(
        ".hero-slide"
    )];

const heroDots =
    [...document.querySelectorAll(
        ".hero-dot"
    )];

const heroPrev =
    document.querySelector(
        "#heroPrev"
    );

const heroNext =
    document.querySelector(
        "#heroNext"
    );

const heroAutoplayToggle =
    document.querySelector(
        "#heroAutoplayToggle"
    );


let currentSlide = 0;
let sliderTimer = null;

const sliderDelay = 6500;


const reducedMotion =
    window.matchMedia(
        "(prefers-reduced-motion: reduce)"
    ).matches;

let autoplayPaused = reducedMotion;
let heroHasFocus = false;
let pointerInsideHero = false;


/* SHOW SLIDE */

function showSlide(index) {

    if (
        !heroSlider ||
        !heroSlides.length
    ) {
        return;
    }


    if (index < 0) {

        index =
            heroSlides.length - 1;

    }


    if (index >= heroSlides.length) {

        index = 0;

    }


    currentSlide = index;


    /* LEFT ARROW POSITION */

    const arrowPositions = [
        "36%",   // Herren
        "37%",   // Damen
        "46%"    // Niche & Unisex
    ];


    heroSlider.style.setProperty(
        "--hero-arrow-left",
        arrowPositions[currentSlide] ??
        "36%"
    );


    heroSlides.forEach(
        (slide, slideIndex) => {

            const active =
                slideIndex === currentSlide;


            slide.classList.toggle(
                "is-active",
                active
            );


            slide.setAttribute(
                "aria-hidden",
                String(!active)
            );

        }
    );


    heroDots.forEach(
        (dot, dotIndex) => {

            dot.classList.toggle(
                "is-active",
                dotIndex === currentSlide
            );

            dot.setAttribute(
                "aria-current",
                String(dotIndex === currentSlide)
            );

        }
    );

}


/* NEXT / PREVIOUS */

function nextSlide() {

    showSlide(
        currentSlide + 1
    );

}


function previousSlide() {

    showSlide(
        currentSlide - 1
    );

}


/* AUTOPLAY */

function stopAutoplay() {

    if (!sliderTimer) {
        return;
    }


    window.clearInterval(
        sliderTimer
    );


    sliderTimer = null;

}


function startAutoplay() {

    if (
        reducedMotion ||
        autoplayPaused ||
        heroHasFocus ||
        pointerInsideHero ||
        document.hidden ||
        !heroSlides.length
    ) {
        return;
    }


    stopAutoplay();


    sliderTimer =
        window.setInterval(
            nextSlide,
            sliderDelay
        );

}


function syncAutoplayControl() {

    if (!heroAutoplayToggle) {
        return;
    }

    const paused =
        autoplayPaused || reducedMotion;

    heroAutoplayToggle.setAttribute(
        "aria-pressed",
        String(paused)
    );

    heroAutoplayToggle.setAttribute(
        "aria-label",
        (reducedMotion
            ? heroAutoplayToggle.dataset.labelReducedMotion
            : paused
                ? heroAutoplayToggle.dataset.labelResume
                : heroAutoplayToggle.dataset.labelPause) ||
        heroAutoplayToggle.getAttribute("aria-label") || ""
    );

    heroAutoplayToggle.disabled =
        reducedMotion;

    const icon =
        heroAutoplayToggle.querySelector(
            "span"
        );

    if (icon) {
        icon.textContent = paused ? "▶" : "Ⅱ";
    }

}


/* BUTTONS */

heroNext?.addEventListener(
    "click",
    () => {

        nextSlide();
        startAutoplay();

    }
);


heroPrev?.addEventListener(
    "click",
    () => {

        previousSlide();
        startAutoplay();

    }
);


heroAutoplayToggle?.addEventListener(
    "click",
    () => {

        if (reducedMotion) {
            return;
        }

        autoplayPaused =
            !autoplayPaused;

        if (autoplayPaused) {
            stopAutoplay();
        } else {
            startAutoplay();
        }

        syncAutoplayControl();

    }
);


/* DOTS */

heroDots.forEach((dot) => {

    dot.addEventListener(
        "click",
        () => {

            const index =
                Number(
                    dot.dataset.slide
                );


            showSlide(index);

            startAutoplay();

        }
    );

});


/* PAUSE WHILE USER INTERACTS */

heroSlider?.addEventListener(
    "mouseenter",
    () => {
        pointerInsideHero = true;
        stopAutoplay();
    }
);


heroSlider?.addEventListener(
    "mouseleave",
    () => {
        pointerInsideHero = false;
        startAutoplay();
    }
);


heroSlider?.addEventListener(
    "focusin",
    () => {
        heroHasFocus = true;
        stopAutoplay();
    }
);


heroSlider?.addEventListener(
    "focusout",
    (event) => {
        heroHasFocus =
            heroSlider.contains(
                event.relatedTarget
            );

        if (!heroHasFocus) {
            startAutoplay();
        }
    }
);


/* =========================================
   MOBILE SWIPE
========================================= */

let touchStartX = 0;
let touchEndX = 0;


heroSlider?.addEventListener(
    "touchstart",
    (event) => {

        touchStartX =
            event.changedTouches[0]
                .screenX;


        stopAutoplay();

    },
    {
        passive: true
    }
);


heroSlider?.addEventListener(
    "touchend",
    (event) => {

        touchEndX =
            event.changedTouches[0]
                .screenX;


        const distance =
            touchEndX -
            touchStartX;


        if (Math.abs(distance) > 50) {

            if (distance < 0) {

                nextSlide();

            } else {

                previousSlide();

            }

        }


        startAutoplay();

    },
    {
        passive: true
    }
);


/* =========================================
   TAB VISIBILITY
========================================= */

document.addEventListener(
    "visibilitychange",
    () => {

        if (document.hidden) {

            stopAutoplay();

        } else {

            startAutoplay();

        }

    }
);


/* =========================================
   RESIZE
========================================= */

window.addEventListener(
    "resize",
    () => {

        if (window.innerWidth > 1080) {

            closeMobileMenu(false);

        } else {

            closeMegaMenu();

        }

    }
);


/* =========================================
   PRODUCT RECOMMENDATIONS
========================================= */

/* =========================================
   PRODUCT CARD VARIANTS
========================================= */

function initializeProductCards(scope = document) {

    const cards =
        [...scope.querySelectorAll(
            "[data-aleva-variant-card]"
        )];


    cards.forEach((card) => {

        if (
            card.dataset.variantCardInitialized ===
            "true"
        ) {
            return;
        }


        const buttons =
            [...card.querySelectorAll(
                "[data-card-variant]"
            )];

        const input =
            card.querySelector(
                "[data-card-variant-input]"
            );

        const price =
            card.querySelector(
                ".product-price"
            );

        const points =
            card.querySelector(
                ".product-points"
            );

        const addButton =
            card.querySelector(
                ".product-add-button"
            );

        const addLabel =
            card.querySelector(
                "[data-card-add-label]"
            );


        if (
            !buttons.length ||
            !input ||
            !price ||
            !addButton
        ) {
            return;
        }


        card.dataset.variantCardInitialized =
            "true";


        const selectVariant =
            (button) => {

                if (!button || card.querySelector(".aleva-card-form")?.dataset.quickAddPending === "true") {
                    return;
                }


                buttons.forEach((item) => {

                    const active =
                        item === button;

                    item.classList.toggle(
                        "is-active",
                        active
                    );

                    item.setAttribute(
                        "aria-pressed",
                        String(active)
                    );
                });


                const available =
                    button.dataset.available ===
                    "true";


                if (button.dataset.variantId) {

                    input.value =
                        button.dataset.variantId;
                }


                if (button.dataset.price) {

                    price.textContent =
                        button.dataset.price;
                }


                if (points && button.dataset.points) {

                    points.textContent =
                        button.dataset.points;
                }


                addButton.disabled =
                    !available;


                if (addLabel) {

                    addLabel.textContent =
                        available
                            ? (
                                addButton.dataset.addLabel ||
                                addLabel.textContent
                            )
                            : (
                                addButton.dataset.soldOutLabel ||
                                addLabel.textContent
                            );
                }
            };


        buttons.forEach((button) => {

            button.addEventListener(
                "click",
                () => selectVariant(button)
            );
        });


        const initialButton =
            buttons.find(
                (button) =>
                    button.classList.contains(
                        "is-active"
                    )
            ) ||
            buttons.find(
                (button) =>
                    button.dataset.available ===
                    "true"
            ) ||
            buttons[0];


        selectVariant(initialButton);
    });
}

function initializeProductRecommendations() {

    const recommendationSections =
        [...document.querySelectorAll(
            "[data-aleva-recommendations]"
        )];


    recommendationSections.forEach((section) => {

        if (
            section.dataset
                .recommendationsInitialized ===
            "true"
        ) {
            return;
        }


        section.dataset
            .recommendationsInitialized =
            "true";


        const loadRecommendations =
            async () => {

                if (
                    !section.dataset.url ||
                    section.dataset
                        .recommendationsLoaded ===
                        "true" ||
                    section.dataset
                        .recommendationsLoading ===
                        "true"
                ) {
                    return false;
                }


                section.dataset
                    .recommendationsLoading =
                    "true";


                try {

                    const response =
                        await fetch(
                            section.dataset.url,
                            {
                                headers: {
                                    Accept:
                                        "text/html"
                                }
                            }
                        );


                    if (!response.ok) {
                        return false;
                    }


                    const html =
                        await response.text();


                    const wrapper =
                        document.createElement(
                            "div"
                        );


                    wrapper.innerHTML = html;


                    const nextSection =
                        wrapper.querySelector(
                            "[data-aleva-recommendations]"
                        );


                    if (
                        nextSection
                            ?.innerHTML
                            .trim()
                    ) {

                        section.innerHTML = nextSection.innerHTML;

                        initializeProductCards(section);

                    }


                    section.dataset
                        .recommendationsLoaded =
                        "true";


                    return true;

                } catch (error) {

                    return false;

                } finally {

                    delete section.dataset
                        .recommendationsLoading;

                }

            };


        if (
            "IntersectionObserver" in window
        ) {

            const observer =
                new IntersectionObserver(
                    async (entries) => {

                        if (
                            !entries[0]
                                ?.isIntersecting
                        ) {
                            return;
                        }


                        const loaded =
                            await loadRecommendations();


                        if (loaded) {
                            observer.disconnect();
                        }

                    },
                    {
                        rootMargin:
                            "0px 0px 320px 0px"
                    }
                );


            observer.observe(section);

        } else {

            loadRecommendations();

        }

    });

}

/* =========================================
   INITIALIZE
========================================= */


function initializeQuickAdd() {
    document.addEventListener("submit", async event => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches(".aleva-card-form")) return;
        const component = form.closest("[data-aleva-quick-add]");
        if (!component || typeof window.fetch !== "function") return;
        event.preventDefault();
        if (form.dataset.quickAddPending === "true") return;
        const button = form.querySelector('button[type="submit"]');
        const input = form.querySelector('[name="id"]');
        const variantId = Number(input?.value);
        const message = component.querySelector("[data-quick-add-message]");
        const cartLink = component.querySelector("[data-quick-add-cart-link]");
        const status = (key, showCart = false) => {
            if (message) message.textContent = component.dataset[key] || component.dataset.quickAddError;
            if (cartLink) cartLink.hidden = !showCart;
        };
        if (!button || button.disabled || !Number.isSafeInteger(variantId) || variantId <= 0) {
            status("quickAddUnavailable");
            return;
        }
        const variantCard = form.closest("[data-aleva-variant-card]");
        const selected = variantCard?.querySelector('[data-card-variant][aria-pressed="true"]');
        if (variantCard && (!selected || Number(selected.dataset.variantId) !== variantId || selected.dataset.available !== "true")) {
            status("quickAddUnavailable");
            return;
        }
        const focusWasOnButton = document.activeElement === button;
        const sizeButtons = [...(variantCard?.querySelectorAll("[data-card-variant]") || [])];
        const disabledStates = sizeButtons.map(b => b.disabled);
        form.dataset.quickAddPending = "true";
        form.setAttribute("aria-busy", "true");
        button.disabled = true;
        button.classList.add("is-loading");
        button.classList.remove("is-added");
        sizeButtons.forEach(b => b.disabled = true);
        if (message) message.textContent = "";
        if (cartLink) cartLink.hidden = true;
        let confirmed = false;
        let definitiveFailure = false;
        try {
            const routeRoot = window.Shopify?.routes?.root || "/";
            const response = await fetch(routeRoot + "cart/add.js", {
                method: "POST",
                credentials: "same-origin",
                headers: {"Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest"},
                body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
            });
            if (!response.ok) {
                definitiveFailure = response.status >= 400 && response.status < 500;
                status(response.status === 422 ? "quickAddUnavailable" : definitiveFailure ? "quickAddError" : "quickAddUncertain", !definitiveFailure);
                return;
            }
            const data = await response.json();
            if (!(data.items || [data]).some(item => Number(item.variant_id || item.id) === variantId && Number(item.quantity) > 0)) throw new Error("Unconfirmed cart response");
            confirmed = true;
            button.classList.add("is-added");
            let cart = null;
            try {cart = await window.ALEVA_SYNC_CART_BADGE?.();} catch (_) {}
            status(cart ? "quickAddSuccess" : "quickAddCounterPending", true);
        } catch (_) {
            status(confirmed ? "quickAddCounterPending" : "quickAddUncertain", true);
            if (!confirmed && !definitiveFailure) {
                try {await window.ALEVA_SYNC_CART_BADGE?.();} catch (_) {}
            }
        } finally {
            delete form.dataset.quickAddPending;
            form.removeAttribute("aria-busy");
            button.classList.remove("is-loading");
            sizeButtons.forEach((b, index) => b.disabled = disabledStates[index]);
            button.disabled = variantCard ? variantCard.querySelector('[data-card-variant][aria-pressed="true"]')?.dataset.available !== "true" : false;
            if (focusWasOnButton && document.activeElement === document.body) button.focus({preventScroll: true});
        }
    });
}

initializeQuickAdd();
initializeProductCards();
document.addEventListener("shopify:section:load", event => initializeProductCards(event.target));

initializeProductRecommendations();
if (
    mobileAccordionSections.length &&
    !mobileAccordionSections.some(
        (section) =>
            section.classList.contains(
                "is-open"
            )
    )
) {

    setMobileAccordion(
        mobileAccordionSections[0]
    );

}


showSlide(0);

syncAutoplayControl();

startAutoplay();

})();

